import { render } from "./AccountResetPassword.vue?vue&type=template&id=602c8114&scoped=true"
import script from "./AccountResetPassword.vue?vue&type=script&lang=js"
export * from "./AccountResetPassword.vue?vue&type=script&lang=js"

import "./AccountResetPassword.vue?vue&type=style&index=0&id=602c8114&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-602c8114"]])

export default __exports__